<template>
  <div class="skeleton-gift-card">
    <!-- Amount Section -->
    <div class="skeleton-amount"></div>

    <!-- Date and Time Section -->
    <div class="skeleton-date-time">
      <div class="skeleton-date"></div>
      <div class="skeleton-time"></div>
    </div>

    <!-- Location Section -->
    <div class="skeleton-location"></div>

    <!-- From Section -->
    <div class="skeleton-from"></div>

    <!-- Note Section -->
    <div class="skeleton-note"></div>

    <!-- Buttons Section -->
    <div class="skeleton-buttons">
      <div class="skeleton-button"></div>
      <div class="skeleton-button"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonGiftCard'
}
</script>

<style scoped>
.skeleton-gift-card {
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  min-height: 395px;
  display: flex;
  flex-direction: column;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Amount Skeleton */
.skeleton-amount {
  height: 48px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 8px;
  margin-bottom: 16px;
  animation: shimmer 2s infinite;
}

/* Date and Time Skeleton */
.skeleton-date-time {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.skeleton-date,
.skeleton-time {
  flex: 1;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 2s infinite;
}

/* Location Skeleton */
.skeleton-location {
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  margin-bottom: 12px;
  width: 70%;
  animation: shimmer 2s infinite;
}

/* From Skeleton */
.skeleton-from {
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  margin-bottom: 12px;
  width: 60%;
  animation: shimmer 2s infinite;
}

/* Note Skeleton */
.skeleton-note {
  height: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  margin-bottom: 16px;
  flex: 1;
  animation: shimmer 2s infinite;
}

/* Buttons Skeleton */
.skeleton-buttons {
  display: flex;
  gap: 10px;
  flex-direction: column;
}

.skeleton-button {
  height: 48px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 6px;
  animation: shimmer 2s infinite;
}

/* Shimmer Animation */
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Pulse Animation */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.95;
  }
}

/* Mobile Responsive */
@media (max-width: 767px) {
  .skeleton-gift-card {
    min-height: 345px;
    padding: 16px;
  }

  .skeleton-amount {
    height: 40px;
    margin-bottom: 12px;
  }

  .skeleton-date-time {
    margin-bottom: 12px;
  }

  .skeleton-date,
  .skeleton-time {
    height: 16px;
  }

  .skeleton-location,
  .skeleton-from {
    height: 16px;
    margin-bottom: 10px;
  }

  .skeleton-note {
    height: 60px;
    margin-bottom: 12px;
  }

  .skeleton-button {
    height: 40px;
  }
}
</style>
